export default __webpack_public_path__ + "static/horizontal-logo-00a63f1e5f9d49f38f6759c779410c4b.svg";